/**
 * Minimal structural fetch types.
 *
 * Declared instead of imported so this file compiles with neither `lib.dom` nor
 * a node-only import: `apps/web` bundles it for the browser, `apps/api` and the
 * tests run it on node, and a test can stub it with a plain object literal.
 */

export interface HeadersLike {
  get(name: string): string | null;
}

export interface StreamReaderLike {
  read(): Promise<{ readonly done: boolean; readonly value?: Uint8Array | undefined }>;
  cancel(): Promise<void>;
}

export interface StreamLike {
  getReader(): StreamReaderLike;
}

export interface ResponseLike {
  readonly ok: boolean;
  readonly status: number;
  readonly headers: HeadersLike;
  readonly body?: StreamLike | null;
  text(): Promise<string>;
}

export interface RequestInitLike {
  readonly method: string;
  readonly headers: Record<string, string>;
  readonly body?: string | undefined;
  /** Refresh cookie must travel on every call, including the refresh itself. */
  readonly credentials?: 'include' | 'omit' | 'same-origin';
  readonly signal?: AbortSignal | undefined;
  readonly cache?: 'no-store' | 'default';
}

export type FetchLike = (url: string, init: RequestInitLike) => Promise<ResponseLike>;

export const JSON_CONTENT_TYPE = 'application/json';
/** Streaming assist responses are newline-delimited JSON — one chunk per line. */
export const NDJSON_CONTENT_TYPE = 'application/x-ndjson';
